import React, { useState, useEffect } from "react";

import "../../App.scss";
import beforeFilterAchievements from "../../achievements";
import AchievementBadge from "./AchievementBadge";

function AchievementPage() {
  const [showOnlyNew, setShowOnlyNew] = useState(false);
  const [filteredAchievements, setFilteredAchievements] = useState([]);

  const achievements = beforeFilterAchievements.filter((achievement) => true);

  const DISABLE_FR_ACHIEVEMENTS = false;

  const newAchievementsCount = achievements.filter(
    (achievement) => achievement.new,
  ).length;

  useEffect(() => {
    if (showOnlyNew) {
      setFilteredAchievements(
        achievements.filter((achievement) => achievement.new),
      );
    } else {
      setFilteredAchievements(achievements);
    }
  }, [showOnlyNew, achievements]);

  return (
    <div className="achievements">
      <h3>Achievements</h3>
      <p className="achievement-page-description">
        There are {achievements.length} achievements to be unlocked in this
        season! The "Teamwork" achievement is a Jackpot with double XP (2400)
        this season as no one managed to unlock it last time.
      </p>
      <div className="achievement-section">
        <div>
          <div className="achievement-container">
            {filteredAchievements
              .sort((a, b) => (a.xp > b.xp ? 1 : -1))
              .map((achievement) => {
                if (
                  achievement.enabled === false ||
                  (DISABLE_FR_ACHIEVEMENTS && achievement.fr_specific)
                )
                  return null;

                return (
                  <>
                    <AchievementBadge
                      achievement={achievement}
                      achievement_page={true}
                    />
                  </>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AchievementPage;
